import script from "./NavBar_Patient.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar_Patient.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__